/** @format */
import axios, { type AxiosResponse } from 'axios';

import { AxiosValidationError } from './types';

export const isAxiosResponse = (response: any): response is AxiosResponse =>
    Boolean(response.data);

export const isAxiosValidationError = (
    error: unknown
): error is AxiosValidationError => {
    return (
        axios.isAxiosError(error) &&
        'validationErrors' in error &&
        error.validationErrors !== null &&
        typeof error.validationErrors === 'object'
    );
};
